<div class="context-view">
  <div class="context-title">{{ 'PROJECT.LIST.TITLE' | translate }}</div>
  <dx-popup
    [title]="'PROJECT_STEP.NEWPROJECT' | translate"
    [showTitle]="true"
    width="450"
    height="350"
    [visible]="popupVisible()"
    (onHidden)="popupVisible.set(false); handlePopupHidden()"
    [hideOnOutsideClick]="false"
    [dragEnabled]="false"
    [showCloseButton]="true"
    contentTemplate="popupContent">
    <dxo-position boundaryOffset="0 200" at="top" [of]="'#right-col'" collision="fit"> </dxo-position>
    <app-new-project-form [onShow]="resetPopupStateEmitter"></app-new-project-form>
  </dx-popup>

  <dx-data-grid
    id="project-grid"
    [dataSource]="projects()"
    keyExpr="Id"
    [showRowLines]="true"
    [showColumnLines]="false"
    [showBorders]="true"
    [noDataText]="''"
    [allowColumnReordering]="false"
    [allowColumnResizing]="false"
    (onRowDblClick)="loadProject($event)">
    <dxo-paging [pageSize]="30"> </dxo-paging>
    <dxo-scrolling
      mode="infinite"
      [useNative]="false"
      [scrollByContent]="true"
      [scrollByThumb]="true"
      showScrollbar="onHover">
    </dxo-scrolling>
    <dxo-search-panel
      [visible]="true"
      [highlightCaseSensitive]="false"
      (textChange)="persistSearchtext($event)"
      [(text)]="searchText"></dxo-search-panel>
    <dxo-master-detail [enabled]="true" [autoExpandAll]="false" [template]="'detail'"> </dxo-master-detail>

    <!-- TOOLBAR -->
    <dxo-toolbar>
      <dxi-item location="before">
        <div *dxTemplate>
          <dx-date-range-box [width]="240" [(value)]="dateRange" (onClosed)="getProjects()" [labelMode]="'hidden'">
          </dx-date-range-box>
        </div>
      </dxi-item>
      <dxi-item [width]="130" name="searchPanel" location="before"></dxi-item>

      <dxi-item name="states" location="before">
        <dx-tag-box
          width="200px"
          [dataSource]="states"
          displayExpr="text"
          valueExpr="id"
          [(value)]="selectedStates"
          (onValueChanged)="onTagBoxValueChanged($event)"
          [showClearButton]="true"
          [searchEnabled]="true"
          [multiline]="false"
          [maxDisplayedTags]="2"
          [showSelectionControls]="true"
          applyValueMode="useButtons"
          stylingMode="outlined">
        </dx-tag-box>
      </dxi-item>

      <dxi-item location="before">
        <div *dxTemplate>
          <dx-button [icon]="'refresh'" (onClick)="getProjects()"> </dx-button>
        </div>
      </dxi-item>

      <dxi-item location="before">
        <div *dxTemplate>
          <dx-button [icon]="'add'" (onClick)="showPopup()"> </dx-button>
        </div>
      </dxi-item>
    </dxo-toolbar>

    <!-- MASTER -->
    <!-- <dxi-column dataField="Id" [caption]="'PROJECT.Id' | translate" [hidden]="true"></dxi-column> -->
    <dxi-column
      dataField="isPrime"
      [width]="30"
      [caption]="'ASSIGNMENT.INFO' | translate"
      alignment="left"
      cellTemplate="cellTemplatePrime"
      cssClass="badge-cell"
      [allowSorting]="false"
      [calculateSortValue]=""
      [sortingMethod]="">
    </dxi-column>
    <div *dxTemplate="let data of 'cellTemplatePrime'" class="mi">
      @if (data.data.isPrime) {
        <app-badge-variant
          badge="none"
          label="PL"
          [shape]="Shape.Shield"
          backgroundColor="var(--prime-logistics-color-1)"
          [tooltip]="'ASSIGNMENT.INFOFILTER.PRIME_LOGISTIC' | translate" />
      }
    </div>
    <dxi-column
      dataField="ProjectNo"
      [caption]="'PROJECT.ProjectNo' | translate"
      alignment="center"
      [calculateCellValue]="utilService.asString"></dxi-column>
    <dxi-column
      dataField="FromDateTime"
      [caption]="'PROJECT.FromDateTime' | translate"
      format="dd.MM.yy HH:mm"
      dataType="datetime">
    </dxi-column>
    <dxi-column
      dataField="UntilDateTime"
      [caption]="'PROJECT.UntilDateTime' | translate"
      format="dd.MM.yy HH:mm"
      dataType="datetime">
    </dxi-column>
    <dxi-column dataField="Vehicle" [caption]="'PROJECT.Vehicle' | translate"></dxi-column>
    <dxi-column dataField="Driver" [caption]="'PROJECT.Driver' | translate"></dxi-column>
    <dxi-column
      dataField="ProcessingState"
      [caption]="'PROJECT.ProcessingState' | translate"
      alignment="center"
      [calculateCellValue]="utilService.asStringTranslated('PROCESSING_STATE.')"></dxi-column>

    <!-- DETAIL -->
    <div *dxTemplate="let item of 'detail'">
      <div class="row">
        <div class="col">
          <div class="dx-field">
            <div class="header">{{ 'PROJECT_DETAIL.Admin' | translate }}</div>

            <div class="field-set">
              <div class="label">{{ 'PROJECT_DETAIL.Administrator' | translate }}:</div>
              <div class="value-static">{{ item.data.Administrator }}</div>
            </div>
          </div>
        </div>

        <div class="col">
          <div class="dx-field">
            <div class="header">{{ 'PROJECT_DETAIL.Weight' | translate }}</div>

            <div class="field-set">
              <div class="label"><app-icon [kind]="'AssignmentPickup'"></app-icon></div>
              <div class="value-static">{{ item.data.PickupWeight | number: '1.2-2' }} t</div>
            </div>

            <div class="field-set">
              <div class="label"><app-icon [kind]="'AssignmentDelivery'"></app-icon></div>
              <div class="value-static">{{ item.data.DeliveryWeight | number: '1.2-2' }} t</div>
            </div>
          </div>
        </div>

        <div class="col">
          <div class="dx-field">
            <div class="header">{{ 'PROJECT_DETAIL.Volume' | translate }}</div>

            <div class="field-set">
              <div class="label"><app-icon [kind]="'AssignmentPickup'"></app-icon></div>
              <div class="value-static">{{ item.data.PickupVolume | number: '1.2-2' }} m³</div>
            </div>

            <div class="field-set">
              <div class="label"><app-icon [kind]="'AssignmentDelivery'"></app-icon></div>
              <div class="value-static">{{ item.data.DeliveryVolume | number: '1.2-2' }} m³</div>
            </div>
          </div>
        </div>

        @if (item.data.AdrPoints && item.data.AdrPoints > 0) {
          <div class="col">
            <div class="dx-field">
              <div class="header">{{ 'PROJECT_DETAIL.AdrPoints' | translate }}</div>
              <div class="field-set">
                <div class="value-static">{{ item.data.AdrPoints }}</div>
              </div>
            </div>
          </div>
        }
      </div>
      <div class="row">
        <div class="label">{{ 'PROJECT_DETAIL.TrapoText' | translate }}:</div>
        <div class="value-static">{{ item.data.TrapoText }}</div>
      </div>
    </div>
  </dx-data-grid>
  <app-loader [hide]="!isLoading()"></app-loader>
</div>
